import { memo } from 'react';
import { Text, Markdown, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import SyncPic from './SyncPic';

const SyncRequired = () => {
    const theme = useTheme();
    return (
        <div className="fm-ee__contentWrapper">
            <SyncPic />
            <Text type="subtitle1" color={theme.colors.utility.textPrimary}>
                {getLiteral('title_sync_required')}
            </Text>
            <Markdown
                content={getLiteral('label_sync_required_desc')}
                overrides={{ p: { type: 'caption', color: theme.colors.utility.textSecondary } }}
            />
        </div>
    );
};

export default memo(SyncRequired);
